// src/router.js
import { createRouter, createWebHistory } from 'vue-router';
import Home from './HomeView.vue';
import EducationSection from './Educative/eduSection.vue';
import stepSection from './Educative/stepSection.vue';
import recSection from './Educative/recSection.vue';
import homeCareSection from './Educative/homeCareSection.vue';
import admissionSection from './Admission/admissionSection.vue';
import costsSection from './Admission/costsSection.vue';
import bookSection from './Admission/bookAppointment.vue';


const routes = [
  { path: '/Home', component: Home },
  { path: '/EduSection', component: EducationSection },
  { path: '/stepSection', component: stepSection },
  { path: '/recSection', component: recSection },
  { path: '/homeCareSection', component: homeCareSection },
  { path: '/admissionSection', component: admissionSection },
   { path: '/costsSection', component: costsSection },
   { path: '/bookSection', component: bookSection },
  { path: '/', redirect: '/Home' } // Redirect to a default section
];

const router = createRouter({
  base: '/Home/',
  history: createWebHistory(),
  routes
});

export default router;
